import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
// import { Link } from "react-router-dom";
import { Modal, Row } from "react-bootstrap";
// import Www_w from "./screens/www";
import { Input } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import { MdMessage, MdAccountCircle, MdPermPhoneMsg, MdMap, MdPhoneBluetoothSpeaker, } from "react-icons/md";
import { IoMdCreate, IoLogoFacebook, IoLogoGoogle } from "react-icons/io";
import { getCokie, signout, isAuth } from "./helpers/auth";
import { BiLogoTiktok } from "react-icons/bi"
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa"
import { FaBloggerB } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa"
import Navigate from "./screens/Navigation";
import { useNavigate } from 'react-router-dom';

import Headroom from "react-headroom";
import Wwwwww from "./screens/downlist";
import Socket from "./screens/Chat";
import authSvg from "./assests/www.jpg";
import authSvgwww from "./assests/foto.png";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, EffectCoverflow, EffectFade, Autoplay, Scrollbar, A11y } from 'swiper';
import { title } from "process";
// import { Swiper, SwiperSlide } from 'swiper/react';
SwiperCore.use([Navigation, Pagination, EffectCoverflow, EffectFade, Autoplay, Scrollbar, A11y])

export default class App extends Component {
  state = {
    files: [],
    news: [],
    zz: [],
    user: [],
    id: "",
    foreign: "",
    type: "",
    select: "",
    title: "",
    detail: "",
    userssocket: [],
    unidades: {
      "_id": "69c06378e32ee49e15dfe334",
      "foreign": "69c04901e747589255dfd688",
      "type": "this.state.user._id",
      "subtype": "image",
      "title": "wwwww",
      "description": "www",
      "usertask": [],
      "user": "63ab4f45a06c6fe92e7a4209",
      "file": "252593a336b04e7b5c50355182cd950e",
      "createdAt": "2026-03-22T21:47:36.957Z",
      "updatedAt": "2026-03-22T21:47:36.957Z",
      "__v": 0
    },
    // name: "",
    showModal: false,
  };

  open = () => this.setState({ showModal: true });
  close = () => this.setState({ showModal: false });

  fileSelectHandler = (files) => {
    console.log(files);
    var array = ["image/jpeg", "image/jpg", "image/png", "image/PNG", "image/svg+xml"];
    console.log(array.includes(files[0].type));
    if (files) {
      if (files[0].size < 105048576 && array.includes(files[0].type)) {
        this.setState({
          files,
        });
      } else {
        toast.dark(
          "Solo se acepta archivos no mayor a 1MB en formatos pdf, jpeg, jpg y png "
        );
      }
    }
  };

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = async (e) => {
    e.preventDefault()
    //console.log(this.state.files[0])
    const data = new FormData()
    data.append("type", this.state.type)
    data.append("subtype", this.state.subtype)
    data.append("title", this.state.title)
    data.append("detail", this.state.detail)
    data.append("foreign", this.state.foreign)
    data.append("user", isAuth()._id)
    data.append("foto", this.state.files[0])
    console.log(this.state.files[0], this.state.title)
    await axios.post(`${process.env.REACT_APP_API_URL}/links/lands`, data);
    // await axios.put(`${process.env.REACT_APP_API_URL}/links/lands/` + isAuth()._id, data);
    this.close()
    toast.dark("Actualizado correctamente")
    this.getNotes();
    this.setState({
      files: [],
      foreign: "",
      i: "",
      select: "",
      title: "",
      detail: "",
    })
  };


  onSubmitUpdate = async (e) => {
    e.preventDefault()
    //console.log(this.state.files[0])
    const data = new FormData()
    data.append("type", this.state.type)
    data.append("subtype", this.state.subtype)
    data.append("title", this.state.title)
    data.append("detail", this.state.detail)
    data.append("foreign", this.state.foreign)
    data.append("user", isAuth()._id)
    data.append("foto", this.state.files[0])
    console.log(this.state.files[0], data)
    // await axios.post(`${process.env.REACT_APP_API_URL}/links/lands`, data);
    await axios.put(`${process.env.REACT_APP_API_URL}/links/lands/` + this.state.id, data);
    this.close()
    toast.dark("Actualizado correctamente")
    this.getNotes();
    this.setState({
      files: [],
      foreign: "",
      type: "",
      select: "",
      title: "",
      detail: "",
    })
  };

  onSubmitRemove = async (id) => {
    const response = window.confirm('Deseas eliminar este capítulo?');
    if (response) {
      await axios.delete(`${process.env.REACT_APP_API_URL}/links/lands/` + id);
      this.getNotes();
      toast.dark('Removido correctamente');
    }
  };


  // removeCookie("id");
  // removeLocalStorage("id");

  getNotes = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/links/lands`, {
      headers: {
        Authorization: `Bearer ${getCokie("token")}`,
      },
    }
    ).then(res => {
      console.log(res.data, "wwwww");
      this.setState({
        zz: res.data,
      });
    }).catch((err) => {
      console.log(err.response.statusText);
      toast.error(`Error To Your Information ${err.response.statusText}`);
      if (err.response.status === 401) {
        // signout(() => {
        // history.push("/login");
        // });
      }
    });
  };


  getnews = async () => {
    await fetch(process.env.REACT_APP_API_URL + "/links/news")
      .then((response) => response.json())
      .then((www) => {
        // setNews(www.reverse())
        // for (const file of www) {
        //   if (file.show == 'true') {
        //     console.log(file)
        //     setDescription(file.description)
        //     setTitle(file.title)
        //     openModal2()
        //     // var texto = file.user;
        //     // return { w1: file.title, w2: file.description, w3: file.img };
        //     // return texto;
        //   }
        // }
        this.setState({
          news: www,
        });
        console.log(www, "wwwwwwwwwwwwwwwwwwwwwww")
      })
      .catch(error => console.error(error))
  }


  openInNewTab = async (url) => {
    window.open(url, "_blank", "noreferrer");
  }
  async componentDidMount() {
    this.getNotes();
    this.getnews()
  }



  remove = (i, j) => {
    console.log(i, j)
    var data = this.state.zz ? this.state.zz : []

    for (var k = 0; k < data.length; k++) {
      if (k == i) {
        var www = data[k].usertask
        www.filter((_, index) => index !== j)
      }
      console.log(data, "www")
      this.setState({ zz: data })
    }
  }

  updatefirst = () => {
    // console.log(event, idwww)
    const data = this.state.zz
    for (var k = 0; k < data.length; k++) {
      for (var j = 0; j < data[k].temas.length; j++) {
        // if (data[k].temas[j]._id === idwww) {
        //   data[k].temas[j].title = event
        //   console.log(data[k].temas[j])
        // }
      }
    }
    this.close()
    // setTitle("wwwww")
    // setWww(wwwww)
    // console.log(wwwww)

    // fetch(`${process.env.REACT_APP_URL}/api/curses/${id}`, {
    //   method: 'put',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(wwwww)
    // })
    //   .then(response => response.json())
    //   .then(data => { toast.info(data); get() })
    //   .catch(error => console.error(error))
  }


  createSesion = () => {
    var data = this.state.zz ? this.state.zz : []
    for (var k = 0; k < data.length; k++) {
      if (k == this.state.i) {
        var www = data[k].usertask
        // console.log(data)
        www.push(
          {
            "title": this.state.title,
            "detail": this.state.detail,
            "link": "",
          }
        )
      }
    }
    this.setState({ zz: data })
    console.log(this.state.zz)
    const id = data[this.state.i]._id


    fetch(`${process.env.REACT_APP_URL}/api/links/lands/${id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.zz[this.state.i])
    })
      .then(response => response.json())
      .then(data => {
        toast.info(data);
        this.close()
      })
      .catch(error => console.error(error))
  }

  createSesionw = (i) => {
    console.log(i)
    // var units = this.state.zz ? this.state.zz : []
    // for (var k = 0; k < units.usertask.length; k++) {
    //   if (k == i) {
    //     var data = units.usertask[k]
    //     data.wwwusertask.push(
    //       {
    //         "new": "Change title",
    //         "newdescription": "www",
    //         "newtask": "www",
    //         "newusertask": [],
    //         "newusertaskteacher": []
    //       }
    //     )
    //   }
    // }
    // this.setState({ zz: units })
  }

  createSesionww = () => {
    var units = this.state.zz ? this.state.zz : []
    for (var k = 0; k < units.usertask.length; k++) {
      if (units.usertask[k].wwwusertask.length > 0) {
        for (var t = 0; t < units.usertask[k].wwwusertask.length; t++) {
          var www = units.usertask[k].wwwusertask[t]
          if (t == 1) {
            www.newusertask.push(
              {
                "title": "Change title",
                "newdescription": "www",
                "newtask": "www",
                "newusertask": [],
                "newusertaskteacher": []
              }
            )
          }
        }
      }
    }
    this.setState({ unidades: units })
    console.log(units)

  }


  createSesionwww = () => {
    var units = this.state.unidades ? this.state.unidades : []
    for (var k = 0; k < units.usertask.length; k++) {
      if (units.usertask[k].wwwusertask.length > 0) {
        for (var t = 0; t < units.usertask[k].wwwusertask.length; t++) {
          if (units.usertask[k].wwwusertask[t].newusertask.length > 0) {
            for (var w = 0; w < units.usertask[k].wwwusertask[t].newusertask.length; w++) {
              if (w == 1) {
                var www = units.usertask[k].wwwusertask[t].newusertask[w]
                www.newusertask.push(
                  {
                    "wwwnew": "Change title",
                    "wwwnewdescription": "www",
                    "wwwnewtask": "www",
                    "wwwnewusertask": [],
                    "wwwnewusertaskteacher": []
                  }
                )
              }
            }
          }
        }
      }
    }
    this.setState({ unidades: units })
  }


  render() {
    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
          closeButton={false}
        />
        <Headroom>
          <Navigate />
        </Headroom>


        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="p-1 col-md-6 text-center">
              <h3 className="p-1 text-center">Escuela Superior de Formación Artística
                Felipe Guamán Poma de Ayala -
                ESFAPA
                Ayacucho</h3>
              <div cassName="text-center">
                Escuela Superior de Formación Artística pública de formación profesional en artes visuales desarrollado                 en un plan de estudios de 5 años ubicado en la ciudad de Ayacucho.
              </div>
              {/* <Link to="/login" className="btn btn-info text-white mx-1" >Saber más</Link> */}
              <a className="btn btn-warning" href="/Cmpt14MVComponent" role="button">Saber más</a>
              <div className="container text-center p-1">
                <a target="_blank" href="https://api.whatsapp.com/send?phone=+51 966878340&text=Hola%20bienvenido" > <IconButton data-title="Wattsapp" style={{ color: "#29a4a0ff" }} > <MdMessage /></IconButton> </a>
                <a target="_blank" href="https://api.whatsapp.com/send?phone=+51 966878340&text=Hola%20bienvenido" > <IconButton data-title="Wattsapp" style={{ color: "#29a4a0ff" }} > <FaFacebook /></IconButton> </a>
                <a className="text-secondary" target="_blank" href="https://m.me/ricardo.mallquib" > <IconButton data-title="Messenger" style={{ color: "#330faaff" }} > <MdPhoneBluetoothSpeaker /> </IconButton> </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/mallquibanos/" > <IconButton data-title="Instagram" style={{ color: "#5b21e3ff" }} > <FaInstagram /> </IconButton> </a>
                <a target="_blank" href="https://rilatex.blogspot.com" > <IconButton data-title="Blogspot" style={{ color: "#5b21e3ff" }} > <IoLogoGoogle /> </IconButton> </a>
                <a target="_blank" href="https://web.facebook.com/ricardo.mallquib" > <IconButton data-title="Facebook" style={{ color: "#5b21e3ff" }} > <BiLogoTiktok />
                </IconButton> </a>
                <a target="_blank" href="https://rilatex.blogspot.com" > <IconButton data-title="Blogspot" style={{ color: "#5b21e3ff" }} > <FaBloggerB /> </IconButton> </a>
                <a target="_blank" href="https://web.facebook.com/ricardo.mallquib" > <IconButton data-title="Facebook" style={{ color: "#5b21e3ff" }} > <FaYoutube />
                </IconButton> </a>
              </div>


            </div>

            <div className="p-1 col-md-6">
              <Swiper
                // install Swiper modules
                modules={[Navigation, Pagination, EffectCoverflow, EffectFade, Autoplay, Scrollbar, A11y]}
                spaceBetween={50}
                // effect="coverflow"
                effect="fade"
                slidesPerView={3}
                grabCursor={true}
                centeredSlides={true}
                // coverflowEffect={{
                //   rotate: 50,
                //   stretch: 0,
                //   depth: 100,
                //   modifier: 1,
                //   slideShadows: true,
                // }}
                fadeEffect={{
                  crossFade: true,
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: true
                }}
                loop={true}
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}
              >
                {this.state.news ? this.state.news.map((www, i) =>
                  <SwiperSlide key={www._id}>
                    <h5 className="bg-info text-center">{www.title}</h5>
                    <img className="img-fluid" src={authSvgwww} alt="Thumb" onClick={this.fotto} onError={(e) => { e.target.src = authSvgwww; e.target.style = "padding: 3px; margin: 1px"; }} />
                  </SwiperSlide>
                ) : ''}
              </Swiper>
            </div>

          </div >




          {/* {isAuth() ? <Socket /> : null} */}
          < Socket />


          <Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
            <Modal.Body>
              {this.state.select == 'subclase' && this.state.subtype != 'link' ? <div className="card form-group">
                <Input type="file" className="custom-file-input" onChange={(e) => { this.fileSelectHandler(e.target.files); }} ></Input>
                <label className="custom-file-label" htmlFor="customFile">
                  Subir archivo
                </label>
              </div> : ""}
              <div className="card form-group">
                <input type="text" placeholder="Título" name="title" onChange={this.onInputChange} value={this.state.title} required />
              </div>
              <div className="card form-group">
                <textarea type="text" placeholder="Detalles" name="detail" onChange={this.onInputChange} value={this.state.detail} required />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button className="btn btn-info" onClick={this.onSubmit}> Crear </button>
              <button className="btn btn-info" onClick={this.onSubmitUpdate}> Actualizar datos </button>
              <button className="btn btn-info" onClick={this.updatefirst}> Actualizar1 </button>
              <button className="btn btn-info" onClick={this.createSesion}> nivel 1 </button>
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { this.close() }}>
                Cerrar
              </button>
            </Modal.Footer>
          </Modal>

          {isAuth() && isAuth().rol === '1' ? (
            <div className="card-body p-3 my-5 text-center">
              <a className="text-center btn btn-secondary" onClick={() => { this.open(); this.setState({ select: "clase", files: [], type: "general", subtype: "image", foreign: isAuth()._id }) }}>Generar clase tipo imagen</a>
              {/* <a className="text-center btn btn-info" onClick={() => { this.createSesion() }}>Generar java</a>
              <a className="text-center btn btn-info" onClick={() => { this.createSesionw() }}>Generar java</a>
              <a className="text-center btn btn-info" onClick={() => { this.createSesionww() }}>Generar 3</a>
              <a className="text-center btn btn-info" onClick={() => { this.createSesionwww() }}>Generar 3</a> */}
            </div>
          ) : null}


          <div className="justify-content-center align-items-center">
            {this.state.zz ? this.state.zz.map((note, i) => (
              <div className="bg-light" key={i} >
                <div className="border bg-warning text-center h5 rounded p-1 mt-3">
                  {note.title}
                </div>
                {isAuth() && isAuth().rol === '1' ? <a className="text-center btn btn-secondary" onClick={() => { this.open(); this.setState({ select: "clase", files: [], type: "general", i: i, foreign: isAuth()._id }) }}>Generar</a> : ''}
                {/* <a className="text-center btn btn-info" onClick={() => { this.createSesion(i) }}>Generar1</a> */}
                <div className="row justify-content-center align-items-center">
                  {note.usertask ? note.usertask.map((notte, j) => (
                    <div className="col-md-6 col-lg-6 p-1" key={j} >
                      <div className="bg-warning rounded p-1">
                        {/* <div className="border border-info rounded p-1"> {notte.title} </div> */}

                        <button className="btn btn-info w-100" onClick={() => { this.openInNewTab(notte.detail) }}>{notte.title}</button>
                        {isAuth() && isAuth().rol === '1' ? <div className="btn btn-group w-100">
                          <button className="btn btn-primary w-100" onClick={() => { this.open(); this.setState({ select: "subclase", files: [], title: notte.title, detail: notte.detail, type: "general", i: i, foreign: isAuth()._id }) }}>edit</button>
                          <a className="text-center btn btn-danger" onClick={() => { this.remove(i, j) }}>remove</a>
                        </div> : ''}
                        <div className="justify-content-center align-items-center">
                          {notte.newusertask ? notte.newusertask.map((nottte, k) => (
                            <div
                              className="border border-warning col-md-6 col-lg-6 p-1"
                              key={k}
                            >
                              <div className="border border-warning rounded p-1 mt-3">
                                {k + 1}
                              </div>

                              <div className="justify-content-center align-items-center">
                                {nottte.newusertask ? nottte.newusertask.map((wnottte, t) => (
                                  <div
                                    className="border border-warning col-md-6 col-lg-6 p-1"
                                    key={t}
                                  >
                                    <div className="border border-warning rounded p-1 mt-3">
                                      {t + 1}
                                    </div>
                                    <a className="text-center btn btn-info" onClick={() => { this.createSesionww() }}>Generar 3</a>
                                    <a className="text-center btn btn-info" onClick={() => { this.createSesionwww() }}>Generar 3</a>

                                  </div>
                                ))
                                  : null}
                              </div>
                            </div>
                          ))
                            : null}
                        </div>
                      </div>

                    </div>
                  ))
                    : null}
                </div>
              </div>
            ))
              : ''}
          </div>

          {/* <Wwwwww /> */}
        </div >
      </>
    );
  }
}


